function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceCbconnect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.4,270.76c2-26.75-4.24-54.7-12.64-79.6-12.47-37-36.67-74.94-77.44-83.69-23.51-5-47.43.36-67.58,13-19.39,12.17-34.5,27.88-58.33,30.93-24.1,3.08-48.83,1.84-73.06,1.84-62.29,0-112.85,65-100.21,132.71s72.22,114.65,122.78,114.65c45.43,0,82.8-27.07,126-34.34,21.4-3.6,42.88.66,64.06-4.74,24.61-6.28,47.75-21.26,61.39-42.95C435.61,303.8,440.13,287.51,441.4,270.76Z",
    style: {
      fill: "#38774B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.4,270.76c2-26.75-4.24-54.7-12.64-79.6-12.47-37-36.67-74.94-77.44-83.69-23.51-5-47.43.36-67.58,13-19.39,12.17-34.5,27.88-58.33,30.93-24.1,3.08-48.83,1.84-73.06,1.84-62.29,0-112.85,65-100.21,132.71s72.22,114.65,122.78,114.65c45.43,0,82.8-27.07,126-34.34,21.4-3.6,42.88.66,64.06-4.74,24.61-6.28,47.75-21.26,61.39-42.95C435.61,303.8,440.13,287.51,441.4,270.76Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.69,
    cy: 417.76,
    rx: 194.55,
    ry: 5.42,
    style: {
      fill: "#2e353a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "345.25 412.82 327.25 412.82 327.25 88.44 345.25 109.37 345.25 412.82",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 336.44 345.08 336.44 327.42 319.37 345.08 319.37 327.42 336.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 318.94 345.08 318.94 327.42 301.87 345.08 301.87 327.42 318.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 371.29 345.08 371.29 327.42 354.22 345.08 354.22 327.42 371.29",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 353.79 345.08 353.79 327.42 336.72 345.08 336.72 327.42 353.79",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 301.44 345.08 301.44 327.42 284.37 345.08 284.37 327.42 301.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 283.94 345.08 283.94 327.42 266.87 345.08 266.87 327.42 283.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 266.44 345.08 266.44 327.42 249.37 345.08 249.37 327.42 266.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 248.94 345.08 248.94 327.42 231.87 345.08 231.87 327.42 248.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 231.44 345.08 231.44 327.42 214.37 345.08 214.37 327.42 231.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 213.94 345.08 213.94 327.42 196.87 345.08 196.87 327.42 213.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 196.44 345.08 196.44 327.42 179.37 345.08 179.37 327.42 196.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 178.94 345.08 178.94 327.42 161.87 345.08 161.87 327.42 178.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 161.44 345.08 161.44 327.42 144.37 345.08 144.37 327.42 161.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 143.94 345.08 143.94 327.42 126.87 345.08 126.87 327.42 143.94",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.42 126.44 345.08 126.44 327.42 109.37 345.08 109.37 327.42 126.44",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.81 126.91 420.09 121.42 357.87 121.42 350.27 126.91 428.81 126.91",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.25,
    y: 126.44,
    width: 152,
    height: 4,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "420.09 121.42 327.25 88.44 357.87 121.42",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.25,
    y1: 88.44,
    x2: 278.25,
    y2: 126.44,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.75,
    y: 134.94,
    width: 37.5,
    height: 24,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.75,
    y: 389.3,
    width: 37.5,
    height: 24,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.56,
    y: 139.94,
    width: 21.87,
    height: 7,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.25,
    y1: 130.44,
    x2: 430.25,
    y2: 173.56,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.85,
    y: 188.28,
    width: 11.11,
    height: 12.59,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "424.85 188.28 430.4 172.74 435.96 188.28",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.17,386.24V364H216.62v22.26a32.21,32.21,0,0,1-7,20l-2.87,3.62H292l-2.88-3.62A32.26,32.26,0,0,1,282.17,386.24Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,401.83H286.2a32.18,32.18,0,0,1-4-15.59V364H216.62v22.26A32.18,32.18,0,0,1,212.59,401.83Z",
    style: {
      fill: "#38774B",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.62,
    y: 367.33,
    width: 65.55,
    height: 9.4,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.66,
    y: 173.4,
    width: 263.47,
    height: 197.6,
    rx: 9.29,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,340.29H381.13a0,0,0,0,1,0,0v21.42a9.29,9.29,0,0,1-9.29,9.29H127a9.29,9.29,0,0,1-9.29-9.29V340.29a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.91,
    y: 185.7,
    width: 236.96,
    height: 139.6,
    style: {
      fill: "#38774B",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.25,355.65a4.86,4.86,0,1,0-4.86,4.85A4.85,4.85,0,0,0,254.25,355.65Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.78,
    y: 409.87,
    width: 85.24,
    height: 3.97,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.51,220.68A23.72,23.72,0,0,0,333,199.36l-14.87,14.87a4.51,4.51,0,0,1-6.36,0l-12.36-12.36a4.5,4.5,0,0,1,0-6.37l14.86-14.86a23.71,23.71,0,0,0-26.64,31.87L249.26,250l-3.7-3.71,6-6a1.67,1.67,0,0,0,0-2.34l-4.68-4.68a1.65,1.65,0,0,0-2.33,0l-2.34,2.34-5.07-5.06,1.95-1.95a2.21,2.21,0,0,0,0-3.12l-41.87-41.87a10.74,10.74,0,0,0-15.2,0l-4.28,4.28a10.73,10.73,0,0,0,0,15.19l41.87,41.88a2.21,2.21,0,0,0,3.12,0l1.95-1.95,5.06,5.07-2.33,2.33a1.65,1.65,0,0,0,0,2.34l4.67,4.68a1.67,1.67,0,0,0,2.34,0l6-6,3.64,3.64-31.82,31a23.72,23.72,0,0,0-31.88,26.64l14.87-14.86a4.5,4.5,0,0,1,6.37,0L214,310.13a4.5,4.5,0,0,1,0,6.37l-14.86,14.86a23.72,23.72,0,0,0,26.65-31.87l31.82-31L301,311.83a8.89,8.89,0,0,0,2,9.5l10.47,10.47,12.56-12.57-10.47-10.46a8.89,8.89,0,0,0-9.5-2l-43.32-43.32L301.15,226A23.72,23.72,0,0,0,326.51,220.68Z",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.15,294.16l75.33-73.49A23.71,23.71,0,0,0,330.35,194l-14.86,14.86a4.5,4.5,0,0,1-6.37,0l-12.36-12.36a4.49,4.49,0,0,1,0-6.36l14.86-14.87A23.71,23.71,0,0,0,285,207.17l-75.33,73.49a23.71,23.71,0,0,0-31.87,26.64l14.86-14.86a4.5,4.5,0,0,1,6.37,0l12.36,12.36a4.49,4.49,0,0,1,0,6.36L196.5,326a23.72,23.72,0,0,0,26.65-31.87Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.35,286.45h0a3.08,3.08,0,0,1,0-4.35l67.73-65.89a3.09,3.09,0,0,1,4.36,0h0a3.09,3.09,0,0,1,0,4.36l-67.73,65.88A3.09,3.09,0,0,1,217.35,286.45Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.85,
    y: 222.86,
    width: 7.16,
    height: 103.31,
    transform: "translate(-114.61 272.33) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.38,313.9l-12.56,12.56L300.35,316a8.89,8.89,0,0,1,0-12.57h0a8.88,8.88,0,0,1,12.56,0Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.64,
    y: 225.37,
    width: 17.63,
    height: 14.32,
    transform: "translate(-97.22 230.36) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.74,169.77h6.06a10.74,10.74,0,0,1,10.74,10.74v59.22a2.2,2.2,0,0,1-2.2,2.2H191.2a2.2,2.2,0,0,1-2.2-2.2V180.51A10.74,10.74,0,0,1,199.74,169.77Z",
    transform: "translate(-86.17 203.67) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.08,
    y: 234.98,
    width: 27.54,
    height: 9.92,
    rx: 1.65,
    transform: "translate(-100.29 237.76) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,233.32,219,236.77l-41.12-41.12a2.44,2.44,0,0,1,0-3.45h0a2.43,2.43,0,0,1,3.45,0Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.31,227.45l-3.46,3.45-41.12-41.12a2.44,2.44,0,0,1,0-3.45h0a2.43,2.43,0,0,1,3.45,0Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,221.58,230.72,225,189.6,183.91a2.44,2.44,0,0,1,0-3.45h0a2.43,2.43,0,0,1,3.45,0Z",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladders--inject-1--inject-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "371.82 415.07 368.49 415.07 346.96 238.41 350.3 238.41 371.82 415.07",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.82 415.07 394.49 415.07 372.96 238.41 376.3 238.41 397.82 415.07",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.51 253.05 350.52 253.05 349.85 247.6 375.85 247.6 376.51 253.05",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.96 273.17 352.97 273.17 352.31 267.72 378.3 267.72 378.96 273.17",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.42 293.29 355.42 293.29 354.76 287.84 380.75 287.84 381.42 293.29",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.87 313.42 357.88 313.42 357.21 307.97 383.2 307.97 383.87 313.42",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.32 333.54 360.33 333.54 359.66 328.09 385.65 328.09 386.32 333.54",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.77 353.66 362.78 353.66 362.12 348.21 388.11 348.21 388.77 353.66",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.22 373.79 365.23 373.79 364.57 368.34 390.56 368.34 391.22 373.79",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.68 393.91 367.68 393.91 367.02 388.46 393.01 388.46 393.68 393.91",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.12,
    y1: 249.74,
    x2: 353.52,
    y2: 249.74,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.92,
    y1: 251.34,
    x2: 357.52,
    y2: 251.34,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.11,
    y1: 251.34,
    x2: 371.31,
    y2: 251.34,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 378.51,
    y1: 270.73,
    x2: 374.11,
    y2: 270.73,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.32,
    y1: 271.73,
    x2: 363.52,
    y2: 271.73,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.12,
    y1: 290.52,
    x2: 363.92,
    y2: 290.52,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.52,
    y1: 292.12,
    x2: 360.32,
    y2: 292.12,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.7,
    y1: 310.31,
    x2: 378.31,
    y2: 310.31,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.31,
    y1: 311.91,
    x2: 374.31,
    y2: 311.91,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.14,
    y1: 371.74,
    x2: 382.89,
    y2: 371.74,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.89,
    y1: 370.24,
    x2: 369.89,
    y2: 370.24,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 381.64,
    y1: 371.74,
    x2: 375.14,
    y2: 371.74,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.39,
    y1: 390.99,
    x2: 374.39,
    y2: 390.99,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 368.89,
    y1: 392.74,
    x2: 376.89,
    y2: 392.74,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.89,
    y1: 331.74,
    x2: 363.14,
    y2: 331.74,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.39,
    y1: 331.24,
    x2: 377.14,
    y2: 331.24,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.97 309.44 173.01 314.6 86.87 247.35 90.84 242.19 176.97 309.44",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.87 309.44 90.84 314.6 176.97 247.35 173.01 242.19 86.87 309.44",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.97 384.98 174.52 391.63 86.87 322.89 89.38 316.18 176.97 384.98",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.87 384.98 87.47 392.78 176.97 322.89 173.01 317.74 86.87 384.98",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4,
    y: 241.48,
    width: 3.5,
    height: 173.6,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.95,
    y: 241.48,
    width: 3.5,
    height: 173.6,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.12 309.44 156.15 314.6 70.02 247.35 73.98 242.19 160.12 309.44",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.02 309.44 73.98 314.6 160.12 247.35 156.15 242.19 70.02 309.44",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.12 384.98 157.66 391.63 70.02 322.89 71.28 316.18 160.12 384.98",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.02 384.98 70.62 392.78 160.12 322.89 156.15 317.74 70.02 384.98",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.54,
    y: 241.48,
    width: 3.5,
    height: 173.6,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.09,
    y: 241.48,
    width: 3.5,
    height: 173.6,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.04,
    y: 239.87,
    width: 101.06,
    height: 5.5,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.62,
    y: 239.87,
    width: 28.05,
    height: 5.5,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.04,
    y: 311.91,
    width: 101.06,
    height: 5.5,
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.62,
    y: 311.91,
    width: 28.05,
    height: 5.5,
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0954300000000001px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.03 415.07 283.12 415.07 293.67 353.26 301.59 353.26 291.03 415.07",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.86 415.07 314.78 415.07 304.22 353.26 296.31 353.26 306.86 415.07",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.35 415.07 395.44 415.07 405.99 353.26 413.9 353.26 403.35 415.07",
    style: {
      fill: "#2e353a",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.18 415.07 427.1 415.07 416.54 353.26 408.63 353.26 419.18 415.07",
    style: {
      fill: "#fff",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.75,
    y: 335.39,
    width: 150.97,
    height: 20.97,
    style: {
      fill: "#38774B",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.43,
    y: 335.39,
    width: 150.97,
    height: 20.97,
    style: {
      fill: "#38774B",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: "0.9727319999999999px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.9 356.36 292.71 356.36 299.33 335.39 286.52 335.39 279.9 356.36",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.62 335.39 317.8 335.39 311.18 356.36 324 356.36 330.62 335.39",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.47 335.39 411.65 335.39 405.03 356.36 417.85 356.36 424.47 335.39",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.18 335.39 380.37 335.39 373.75 356.36 386.56 356.36 393.18 335.39",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.9 335.39 349.08 335.39 342.46 356.36 355.28 356.36 361.9 335.39",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.57,
    y1: 344.7,
    x2: 402.59,
    y2: 344.7,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 427.13,
    y1: 348.2,
    x2: 423.19,
    y2: 348.2,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.79,
    y1: 347.33,
    x2: 301.77,
    y2: 347.33,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.22,
    y1: 343.38,
    x2: 308.78,
    y2: 343.38,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceCbconnect);
export default __webpack_public_path__ + "static/media/Maintenance-cbconnect.1e69f18d6336510e82eee3aeb5278d8a.svg";
export { ForwardRef as ReactComponent };